import { render, staticRenderFns } from "./LayoutOnboarding.vue?vue&type=template&id=dfe4ba6a&scoped=true"
import script from "./LayoutOnboarding.vue?vue&type=script&lang=js"
export * from "./LayoutOnboarding.vue?vue&type=script&lang=js"
import style0 from "./LayoutOnboarding.vue?vue&type=style&index=0&id=dfe4ba6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe4ba6a",
  null
  
)

export default component.exports